var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook02SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78189 2.66984C10.7714 1.71255 12.1341 1.25 13.643 1.25L17.9994 1.25C18.4137 1.25 18.75 1.58579 18.75 2V5.5C18.75 5.91421 18.4142 6.25 18 6.25H15C14.0911 6.25 13.9129 6.47208 13.8721 6.53267C13.8351 6.58757 13.7975 6.68012 13.7747 6.85151C13.7512 7.02923 13.75 7.23159 13.75 7.5V8.75H18C18.231 8.75 18.449 8.8564 18.5912 9.03844C18.7333 9.22048 18.7836 9.45785 18.7276 9.6819L17.7276 13.6819C17.6441 14.0158 17.3442 14.25 17 14.25H13.75V22C13.75 22.4142 13.4142 22.75 13 22.75H9C8.58579 22.75 8.25 22.4142 8.25 22V14.25H5C4.58579 14.25 4.25 13.9142 4.25 13.5V9.5C4.25 9.08579 4.58579 8.75 5 8.75H8.25V6.7C8.25 5.01549 8.78789 3.63147 9.78189 2.66984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook02SolidStandard);
export default __webpack_public_path__ + "static/media/facebook-02-solid-standard.1b18e91666f4a35d5bbc70a2dce95c95.svg";
export { ForwardRef as ReactComponent };